import { FeedbackExecutionComponent } from "./feedback-execution.component";
import { FeedbackExecutionActionsModalComponent } from "./feedbackExecutionActionsModal/feedback-execution-actions-modal.component";
export const FeedbackExecutionModule = angular
    .module('feedbackExecution', [])
    .component(FeedbackExecutionComponent.selector, FeedbackExecutionComponent.component)
    .component(FeedbackExecutionActionsModalComponent.selector, FeedbackExecutionActionsModalComponent.component)
    .name;
//# sourceMappingURL=feedback-execution.module.js.map